import { RatesListContainer } from './components/containers/RatesListContainer';
import './i18n';

export const RatesList = () => {
  return (
    <div className="h-full">
      <RatesListContainer />
    </div>
  );
};
